module.exports = __webpack_public_path__ + "img/2.27045a52.png";